import i18next, { t } from 'i18next';
import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  Language,
  de,
  en,
  fr,
  nl,
} from '..';
import intervalPlural from "i18next-intervalplural-postprocessor";

/**
 * All available translations, mapped per language.
 */
export const TRANSLATION_RESOURCES = {
  nl: {
    translation: nl,
  },
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  de: {
    translation: de,
  },
};

/**
 * Default translation configuration.
 */
export const translationConfig = () => ({
  lng: DEFAULT_LANGUAGE,
  fallbackLng: FALLBACK_LANGUAGE,
  resources: TRANSLATION_RESOURCES,
});

/**
 * Initializes the translation library.
 */
export const initializeTranslations = () => {
  if (!i18next.isInitialized) {
    i18next
      .use(intervalPlural)
      .init(translationConfig());
  }
};

/**
 * Translates the given key to the current language.
 *
 * @param key Translation key as defined in the translation files.
 * @param options Options to pass to the translation function.
 * @returns The translated string (or error message).
 */
export const translate = (key: string, options = {}) => {
  return t(key, {
    defaultValue: `Missing translation for key: ${key}`,
    lng: i18next.language ?? DEFAULT_LANGUAGE,
    ...options,
  });
};

/**
 * Listen for language changes.
 *
 * @param callback Function to execute when the language changes.
 */
export const onLanguageChanged = (callback: () => void) => {
  i18next.on('languageChanged', callback);
};

/**
 * Changes the current language.
 * @param language The language to change to.
 */
export const changeLanguage = (language: Language) => {
  i18next.changeLanguage(language);
};
